import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
	base: {
		borderRadius: '6px',
		width: 'fit-content',
	},
	variants: {
		variant: {
			solid: {
				bg: 'brand.primary.500',
				color: 'white',
				_hover: {
					bg: 'brand.primary.600',
				},
				_disabled: {
					bg: 'brand.primary.600',
				},
			},
			outline: {
				bg: 'brand.secondary.500',
				color: 'black',
				border: '1px rgba(100, 55, 159, 1) solid',
				_hover: {
					bg: 'brand.secondary.600',
				},
			},
			subtle: {
				bg: 'red.700',
				color: 'white',
				_hover: {
					bg: 'red.700',
				},
			},
			outlineSecondary: {
				backgroundColor: 'white',
				color: 'brand.primary.500',
				borderWidth: '1px',
				borderColor: 'border',
				_disabled: {
					bg: 'brand.secondary.600',
				},
				_hover: {
					bg: 'brand.secondary.600',
				},
			},
		},
		size: {
			sm: {
				fontSize: 'sm',
				px: 6,
				h: 10,
			},
		},
	},
	defaultVariants: {
		variant: 'solid',
		size: 'sm',
	},
});
